import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { baseAPI } from '../../../config';
import { toast } from 'react-toastify';
import { PencilSquareIcon } from '@heroicons/react/24/outline';
import ModalSimple from '../../ModalSimple';
import CreateAssignmentForm from './CreateAssignmentForm';

const EditAssignmentModal = ({ assignment, onAssignmentUpdated }) => {
  const [submitting, setSubmitting] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [assignmentData, setAssignmentData] = useState(null);

  // Fetch full assignment data when modal opens
  useEffect(() => {
    if (isOpen && assignment?._id) {
      fetchAssignmentData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, assignment]);

  const fetchAssignmentData = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${baseAPI}/assignments/${assignment._id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setAssignmentData(response.data);
    } catch (error) {
      console.error('Error fetching assignment:', error);
      toast.error('Error al cargar el assignment');
      setIsOpen(false);
    }
  };

  const handleFormSubmit = async assignmentFormData => {
    try {
      setSubmitting(true);
      const token = localStorage.getItem('token');

      await axios.put(`${baseAPI}/assignments/${assignment._id}`, assignmentFormData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success('Gestión actualizada');
      setIsOpen(false);

      if (onAssignmentUpdated) {
        onAssignmentUpdated();
      }
    } catch (error) {
      console.error('Error updating assignment:', error);
      if (error.response?.status === 401) {
        toast.error('Sesión expirada. Por favor, inicia sesión nuevamente');
      } else if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error('Error al actualizar el assignment');
      }
    } finally {
      setSubmitting(false);
    }
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
    setAssignmentData(null);
  };

  if (!assignment) {
    return null;
  }

  return (
    <>
      <button
        onClick={handleOpen}
        className='text-slate-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors'
        title='Editar assignment'
        aria-label='Editar assignment'
      >
        <PencilSquareIcon height={14} width={14} />
      </button>

      <ModalSimple id='edit-assignment-modal' title='Editar gestión' show={isOpen} onClose={handleClose} size='lg'>
        {isOpen && assignmentData && (
          <CreateAssignmentForm
            expedientId={
              typeof assignmentData.expedient_id === 'object'
                ? assignmentData.expedient_id._id || assignmentData.expedient_id.expedient_id
                : assignmentData.expedient_id || assignment.expedient_id
            }
            assignment={assignmentData}
            onSubmit={handleFormSubmit}
            onCancel={handleClose}
            isSubmitting={submitting}
          />
        )}
      </ModalSimple>
    </>
  );
};

export default EditAssignmentModal;
